import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, getAuth, setAuth } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getAuth());
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (getAuth()?.token) {
        try {
          const { data } = await api.get("/auth/me");
          if (alive) setUser({ ...getAuth(), username: data.username });
        } catch {
          setAuth(null);
          if (alive) setUser(null);
        }
      }
      if (alive) setChecking(false);
    })();
    return () => {
      alive = false;
    };
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setAuth(data);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(() => {
    setAuth(null);
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, checking, login, logout }),
    [user, checking, login, logout]
  );

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
